<template>
	<Dialog :visible="props.visible" :header="`Autorização (${ctrl.modulo.value}-${ctrl.liberacao.value})`"
		:show-header="true" style="min-width:80vw; max-width:80vw; max-height:100%" content-class="p-0" :closable="false"
		modal :pt="{
			mask: {
				// 	style: 'backdrop-filter: blur(2px)',
			}
		}" @show="onDialogShow">
		<div class="corpo-autorizacao">
			<!--
				Antes o cadeado de 200×200 e os campos dividiam uma linha centralizada,
				e cada R3FieldSet levava `p-6` (3rem) de padding interno: no coletor a
				imagem tomava metade da largura e sobrava uma faixa estreita onde os
				campos apareciam espremidos e desalinhados entre si.

				Agora o cadeado é um ícone de tamanho fixo ao lado do texto, e os campos
				ocupam a largura toda do diálogo, um por linha.
			-->
			<header class="cabecalho-autorizacao">
				<img src="~assets/images/cadeado.jpg" alt="" aria-hidden="true">
				<div>
					<!--
						A descrição vem da própria `USUARIO_AUTORIZACAO_852`
						(`DESC_LIBERACAO_852`). Sem ela o operador via só "W-25" no título
						e não tinha como saber o que estava autorizando.
					-->
					<p class="descricao-liberacao">
						{{ ctrl.descricaoLiberacao.value || "Liberação não cadastrada para esta empresa." }}
					</p>
					<p class="codigo-liberacao">
						Módulo {{ ctrl.modulo.value }} · liberação {{ ctrl.liberacao.value }}
					</p>
				</div>
			</header>

			<div class="campos-autorizacao">
				<R3FieldSet title="Usuário" slot-class="flex p-input-sm w-full">
					<R3Input ref="usuarioRef" v-model:input-value="ctrl.usuarioLiberacao.value" input-i-d="inputUsuario"
						type="number" mode="numeric" :passthrough="{ root: { id: 'inputUsuario' } }" icon="pi-search"
						:disabled-input="false" :button-visible="false" @keydown:enter="onUsuarioKeyDown" />
				</R3FieldSet>
				<R3FieldSet title="Senha" slot-class="flex p-input-sm w-full">
					<!--
						`password` é o que mascara: o R3Input só troca o InputText pelo
						componente Password quando essa prop está presente. O campo tinha
						apenas `mode="password"`, que define o `inputmode` do teclado e
						nada mais — a senha era digitada à vista de todos.

						`feed-back` desligado porque aqui não se cria senha, se digita uma
						existente; o medidor de força não teria função.
					-->
					<R3Input
						ref="senhaRef" v-model:input-value="ctrl.senhaLiberacao.value" input-i-d="inputSenha"
						password :feed-back="false" mode="password" :passthrough="{ root: { id: 'inputSenha' } }"
						:disabled-input="false" :button-visible="false" @keydown:enter="onUsuarioKeyDown" />
				</R3FieldSet>
				<!--
					Motivo: só aparece quando a liberação pede, como o
					`PanelMotivo.Visible := bMotivo` do `FUNC_SENHA_AUTORIZA.pas:281`.
					A W33 (corte na conferência consolidada) é uma das que pedem — o
					Delphi a chama por `SenhaParaAutorizacao_UsuLibMotivo`.

					Campo de texto livre, e não numérico com lupa como estava antes
					escondido aqui: no original é um `TMemo`, o autorizador escreve a
					justificativa. O motivo por CÓDIGO é outra coisa, do corte em si
					(tabela 722), e não desta janela.
				-->
				<R3FieldSet v-if="ctrl.solicitaMotivo.value" title="Motivo" slot-class="flex p-input-sm w-full">
					<Textarea
						id="inputMotivo" v-model="motivoTexto" rows="3" auto-resize
						class="w-full" placeholder="Informe o motivo da liberação" />
				</R3FieldSet>
			</div>

			<div class="rodape-autorizacao">
				<!--
					Confirmar e cancelar ficam só no ícone: são o par de sempre, o
					operador reconhece de imediato e assim sobra largura para o terceiro,
					que precisa do rótulo por não ser óbvio.
				-->
				<div id="toolbar" class="flex gap-2">
					<Button icon="pi pi-check" aria-label="Confirmar" title="Confirmar" @click="onConfirmButtonClick" />
					<Button
						icon="pi pi-times" severity="secondary" outlined aria-label="Cancelar" title="Cancelar"
						@click="onCloseDialog" />
					<Button
						label="Quem libera" icon="pi pi-list" severity="secondary" outlined
						:loading="carregandoUsuarios" @click="onListarUsuariosComPermissao" />
				</div>
				<p class="nota-rodape">Cadastro de liberação na rotina 1152.</p>
			</div>
		</div>
	</Dialog>

	<!--
		Era `title=`, que o PrimeVue Dialog ignora — o correto é `header=`. A janela
		abria sem título nenhum, e como a lista costuma vir vazia (a liberação pode
		não ter usuário cadastrado) o efeito era de botão que "não faz nada".
	-->
	<Dialog header="Quem pode liberar" modal :visible="ctrl.dialogUsuariosComPermissaoVisible.value"
		:style="{ width: '92vw', maxWidth: '30rem' }" @update:visible="ctrl.closeUsuariosComPermissaoDialog">
		<p v-if="ctrl.usuariosComPermissao.value.length === 0" class="p-3 text-center">
			Nenhum usuário tem a liberação {{ ctrl.modulo.value }}-{{ ctrl.liberacao.value }}
			nesta empresa. Cadastre na rotina 1152.
		</p>
		<!--
			Tabela simples, sem rolagem virtual.

			O R3DataTable vem preparado para lista grande dentro de tela cheia:
			`scrollable`, `scroll-height="flex"`, `h-full` e um virtual scroller de
			`itemSize: 50`. Dentro de um Dialog — conteúdo com `height: auto` — a
			altura resolve em zero, o virtual scroller conclui que nenhuma linha cabe
			e a tabela aparece em branco, mesmo com os dados carregados.

			Aqui a lista tem poucas linhas e não precisa de nada disso: desligar a
			rolagem faz a tabela crescer com o conteúdo, que é o comportamento certo
			para este caso.
		-->
		<div v-else class="lista-quem-libera">
			<R3DataTable
				key-field="USU_FK_852" :table-values="ctrl.usuariosComPermissao.value"
				:fields-header="['Id Usu', 'Nome']" :fields="['USU_FK_852', 'DESCR_754']"
				:scrollable="false" :virtual-scroller-options="null" grid-lines />
		</div>
	</Dialog>
	<R3NumberCaptcha ref="captcha" :mostrarCaptcha="captchaVisible" @confirm-click="() => { }"
		@captcha-opened="() => { }" />
</template>

<script lang="ts" setup>
	//TODO alterar a B321 para se adequear ao novo modo de funcionamento da autorização avulsa

	import type { R3AutorizacaoAvulsaExposedProps, R3AutorizacaoAvulsaProps } from "~/types/components/R3/autorizacaoavulsa.types";
	import type { R3InputExposedProps } from "~/types/components/R3/input.types";
	import R3NumberCaptcha from "./R3NumberCaptcha.vue";

	const props = withDefaults(defineProps<R3AutorizacaoAvulsaProps>(), { visible: false });
	const userStore = useUserStore();
	const { $r3fetchdata } = useNuxtApp();
	const { msgDlg, msgDlgShowStatus } = useMessageDlg();
	const ctrl = useAutorizacaoAvulsa();
	const captchaVisible = ref(false);

	// template refs
	const usuarioRef = ref<R3InputExposedProps>();

	/** O `Textarea` trabalha com string; o composable guarda `string | null`. */
	const motivoTexto = computed({
		get: () => ctrl.motivo.value ?? "",
		set: (valor: string) => { ctrl.motivo.value = valor; },
	});

	onMounted(async () => {
		await nextTick(() => {
			usuarioRef.value?.setFocus({ limparCampo: true });
		});
	});

	function onUsuarioKeyDown(event: KeyboardEvent) {
		if (event.key === "Enter") {
			void onConfirmButtonClick();
		}
	}

	function onDialogShow() {
		nextTick(() => {
			usuarioRef.value?.setFocus({ limparCampo: true });
		});

		// Busca em silêncio só para saber a descrição da liberação. A mesma
		// consulta serve aos dois propósitos: quem pode liberar e o que é a
		// liberação (`DESC_LIBERACAO_852` vem em toda linha).
		void carregarUsuariosComPermissao(false);
	}

	function onCloseDialog() {
		ctrl.handleResponse(false);
		ctrl.close();
	}

	watch(msgDlgShowStatus, (newStatus) => {
		if (newStatus === "closed") {
			nextTick(() => {
				usuarioRef.value?.setFocus({ limparCampo: true });
				ctrl.onMessageDialogClosed(() => {
					usuarioRef.value?.setFocus({ limparCampo: true });
				});
			});
		}
	});

	const carregandoUsuarios = ref(false);

	/**
	 * Quem pode liberar esta autorização.
	 *
	 * @param abrirJanela `false` na abertura do diálogo, quando só interessa a
	 * descrição da liberação.
	 */
	async function carregarUsuariosComPermissao(abrirJanela = true) {
		if (userStore.companyID == null)
			return;

		carregandoUsuarios.value = true;
		try {
			const lista = await $r3fetchdata.post<
				{ USU_FK_852: number; DESCR_754: string; DESC_LIBERACAO_852?: string | null }[]
			>(
				"/api/autorizacoes/recuperarQuemTemAcessoAutorizacaoAvulsa" as never,
				ctrl.buildListarUsuariosParams(userStore.companyID, userStore.userID),
			);

			// Lista vazia é resposta legítima: quer dizer que ninguém tem a
			// liberação. Antes o `if (lista)` engolia esse caso e a janela nunca
			// abria, o que parecia botão quebrado.
			ctrl.setUsuariosComPermissao(lista ?? [], abrirJanela);
		}
		catch (erro) {
			console.error("[autorização] não foi possível listar quem libera:", erro);
			ctrl.setUsuariosComPermissao([], abrirJanela);
		}
		finally {
			carregandoUsuarios.value = false;
		}
	}

	function onListarUsuariosComPermissao() {
		return carregarUsuariosComPermissao(true);
	}

	async function onConfirmButtonClick() {
		if (userStore.companyID == null)
			return;

		/*
		 * Mesma recusa do original: `if EditMotivo.Text = '' then raise
		 * 'Informe o Motivo!'` (`FUNC_SENHA_AUTORIZA.pas:320-322`). Vem antes da
		 * validação de senha para não gastar a ida ao servidor.
		 */
		if (ctrl.solicitaMotivo.value && motivoTexto.value.trim() === "") {
			await msgDlg("Autorização", "atencao", "Informe o Motivo!", ["OK"]);
			return;
		}

		// Checa se usuário está ativo
		await checarUsuarioAtivo(userStore.userID);

		try {
			const res = await $r3fetchdata.post(
				"/api/autorizacoes/validarAutorizacaoAvulsa" as never,
				ctrl.buildValidarAutorizacaoParams(
					userStore.companyID,
					userStore.userID,
					ctrl.modulo.value,
					ctrl.liberacao.value,
				),
			);

			if (res) {
				ctrl.handleResponse(true);
			} else {
				ctrl.handleResponse(false);
			}
		} catch (e) {
			const error = e as { response?: { data?: { error?: string } } };
			await msgDlg(
				`Usuário ${ctrl.usuarioLiberacao.value} não autorizado`,
				"informa",
				error.response?.data?.error ?? "",
				["OK"],
			);
		}

		ctrl.clearAfterConfirm();
	}

	async function checarUsuarioAtivo(usuario: number) {
		// const usuarioAtivo = await $r3fetchdata.get<ChecaUsuarioAtivoResponse, ChecaUsuarioAtivoRequest>(
		// 	"/api/usuarios/usuarioativo",
		// 	{ params: { USUARIO: usuario } },
		// );

		// if (usuario === null) {
		// 	// TODO tratar usuário inativo
		// }
	}

	export type R3AutorizacaoAvulsaExpose = R3AutorizacaoAvulsaExposedProps;

	type ExposeType = R3AutorizacaoAvulsaExposedProps;
	const expose = {} as ExposeType;


	useExposeProperties(expose, ctrl)


	defineExpose(expose);
</script>

<style scoped lang="scss">
	.corpo-autorizacao {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		padding: 1rem;
	}

	.cabecalho-autorizacao {
		display: flex;
		align-items: center;
		gap: 0.9rem;

		/* Tamanho fixo e discreto: antes eram 200×200 recortados, e no coletor a
		   imagem tomava metade da largura útil do diálogo. */
		img {
			flex: 0 0 auto;
			width: 3rem;
			height: 3rem;
			object-fit: cover;
			border-radius: 6px;
		}
	}

	.descricao-liberacao {
		margin: 0;
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.3;
	}

	.codigo-liberacao {
		margin: 0.15rem 0 0;
		font-size: 0.8rem;
		color: var(--text-color-secondary, #6c7a86);
	}

	/* Um campo por linha, ocupando a largura toda — o `p-6` de antes empurrava
	   o input para uma faixa estreita e desalinhava usuário e senha entre si. */
	.campos-autorizacao {
		display: flex;
		flex-direction: column;
		gap: 0.6rem;

		:deep(.p-inputtext) {
			width: 100%;
			font-size: 1.15rem;
		}
	}

	.rodape-autorizacao {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.nota-rodape {
		margin: 0;
		font-size: 0.8rem;
		color: var(--text-color-secondary, #6c7a86);
	}

	/* Cresce com o conteúdo até um teto; a rolagem, quando precisa, é daqui —
	   a da própria tabela está desligada. */
	.lista-quem-libera {
		max-height: 55vh;
		overflow-y: auto;

		/* O contêiner do R3DataTable pede `h-full`; num pai de altura automática
		   isso resolve em zero. Aqui a altura tem de vir do conteúdo. */
		:deep(.r3-datatable-container),
		:deep(.r3-datatable) {
			height: auto !important;
			overflow: visible !important;
		}
	}
</style>
